// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hfmxgpcLn4W4GioEOSgID"};